import { AssetsService } from "app/services/AssetsService";

export const LOADERS = new Array(4).fill(0) as number[];
export const EMPTY_IMG_WIDTH = 164;
export const EMPTY_IMG_HEIGHT = 164;
export const HOURGLASS_IMG_SRC = AssetsService.assetUrl("images/activation-alerts/hourglass.png");
